/**
 * Mekanik registry'si.
 *
 * Yeni mekanik eklemek = bir klasor + buraya bir satir.
 *
 * Legacy'de bu is SessionPage.razor icinde 14 `if`'lik bir dispatch zinciriyle
 * ve o zincirin birebir kopyalanmis ikinci bir surumuyle yapiliyordu
 * (tablet/desktop). Bu yapida oyle bir zincir olusamaz.
 */

import type { MechanicComponent, MechanicId } from "./types";
import { ChoiceItem } from "./ChoiceItem";
import { CompositeItem } from "./CompositeItem";
import { AssignmentItem } from "./AssignmentItem";
import { ApplicatorTallyItem } from "./ApplicatorTallyItem";
import { ApplicatorEntryItem } from "./ApplicatorEntryItem";
import { ChoiceGridItem } from "./ChoiceGridItem";
import { AudioTapItem } from "./AudioTapItem";
import { ColumnMatchItem } from "./ColumnMatchItem";
import { TimedRecallItem } from "./TimedRecallItem";
import { MatchItem } from "./MatchItem";
import { OrderItem } from "./OrderItem";

const registry: Partial<Record<MechanicId, MechanicComponent>> = {
  "choice.v1": ChoiceItem,
  "composite.v1": CompositeItem,
  "assignment.v1": AssignmentItem,
  "applicator-tally.v1": ApplicatorTallyItem,
  "applicator-entry.v1": ApplicatorEntryItem,
  "choice-grid.v1": ChoiceGridItem,
  "audio-tap.v1": AudioTapItem,
  "column-match.v1": ColumnMatchItem,
  "timed-recall.v1": TimedRecallItem,
  "match.v1": MatchItem,
  "order.v1": OrderItem,
};

export function resolveMechanic(id: MechanicId): MechanicComponent | null {
  return registry[id] ?? null;
}

export function registeredMechanics(): MechanicId[] {
  return Object.keys(registry) as MechanicId[];
}
